var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "offcanvas-body" }, [
      _c("div", { staticClass: "offcanvas-body-inner" }, [
        _c("div", { staticClass: "text-right" }, [
          _c(
            "a",
            {
              staticClass: "text-danger btn-sm pr-0",
              attrs: { href: "#" },
              on: { click: _vm.clearCart },
            },
            [
              _c("i", {
                staticClass: "mr-1",
                staticStyle: { width: ".85rem", height: ".85rem" },
                attrs: { "data-feather": "x" },
              }),
              _vm._v("Очистить корзину"),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "widget widget-featured-entries pt-3" },
          [
            _vm._l(_vm.cartProducts, function (product) {
              return _c("div", { staticClass: "mb-4" }, [
                _c("div", { staticClass: "media" }, [
                  _c("div", { staticClass: "featured-entry-thumb mr-3" }, [
                    _c("a", { attrs: { href: product.url } }, [
                      _c("img", {
                        attrs: {
                          src: _vm.getResizedPhoto(product.id),
                          alt: product.productName,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "item-remove-btn",
                        on: {
                          click: function ($event) {
                            return _vm.removeProductFromCart(product.id)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-times",
                          attrs: {
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            title: "Удалить",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "featured-entry-title d-flex justify-content-between flex-row",
                      },
                      [
                        _c("a", { attrs: { href: product.url } }, [
                          _vm._v(_vm._s(product.productName)),
                        ]),
                        _c("span", { staticClass: "text-muted font-size-sm" }, [
                          _vm._v("Артикул: " + _vm._s(product.code)),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "featured-entry-meta" }, [
                      _vm._v(_vm._s(product.count) + " "),
                      _c("span", { staticClass: "text-muted" }, [_vm._v("x")]),
                      _vm._v(" " + _vm._s(product.price) + " ₽"),
                    ]),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center py-3",
              },
              [
                _c("div", { staticClass: "font-size-sm" }, [
                  _c("span", { staticClass: "mr-2" }, [_vm._v("Итого:")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "font-weight-semibold text-dark" },
                    [_vm._v(_vm._s(_vm.totalSum) + " ₽")]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
            _vm._m(2),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "offcanvas-header d-flex justify-content-between align-items-center",
      },
      [
        _c("h3", { staticClass: "offcanvas-title" }, [_vm._v("Корзина")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "offcanvas",
              "aria-label": "Close",
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary btn-sm",
        attrs: { href: "/Order/Cart" },
      },
      [
        _vm._v("\n\t\t\t\t\t\tПерейти в корзину"),
        _c("i", {
          staticClass: "mr-n2",
          attrs: { "data-feather": "chevron-right" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn btn-primary btn-sm btn-block",
        attrs: { href: "/Order/Checkout" },
      },
      [
        _c("i", {
          staticClass: "mr-1",
          attrs: { "data-feather": "credit-card" },
        }),
        _vm._v("Заказать"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }